import { render } from "./CompError.vue?vue&type=template&id=b84b3c24"
import script from "./CompError.vue?vue&type=script&lang=js"
export * from "./CompError.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__